import { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';
import { SHOW_TOAST } from '../actions';
import toastWorker from './toast-worker';

export default function* toastWatcher(): SagaIterator {
  yield takeLatest(SHOW_TOAST, toastWorker);
}
